<template>
  <div class="container-map">
    <MapChart
      :countryData="dataMap"
      highColor="#B91E2B"
      lowColor="#ffffff"
      countryStrokeColor="#ffffff"
      defaultCountryFillColor="
    #b91e2b57"

    />
  </div>
</template>

<script>
import MapChart from "vue-map-chart";
export default {
  name: "MyCheckboxMap",
  components: {
    MapChart,
  },
  mounted() {
  },
  data() {
    return {
      dataMap: {
        IN: {
          agua: "6 pozos de agua",
          beneficiarios: "5000 beneficiados",
        },
        PE: {
          agua: "5 sistemas de recolección",
          beneficiarios: "266 beneficiadas",
        },
        CD: {
          agua: "1 depósito de agua",
          beneficiarios: "2500 beneficiados",
        },
        BJ: {
          agua: "1 pozo de agua",
          beneficiarios: "200 beneficiados",
        },
        CM: {
          agua: "2 pozos de agua",
          beneficiarios: "2960 beneficiados",
        },
        GM: {
          agua: "1 pozo de agua",
          beneficiarios: "900 beneficiarios",
        },
        TZ: {
          agua: "5 depósitos de agua",
          beneficiarios: "3600 beneficiados",
        },
        MZ: {
          agua: "2 pozos de agua",
          beneficiarios: "1812 beneficiados",
        },
        HT: {
          agua: "10 depósitos de agua",
          beneficiarios: "2500 beneficiados",
        },
        AO: {
          agua: "2 Mejoras en las Infraestructuras de agua y saneamiento",
          beneficiarios: "11.550 beneficiados",
        },
        MA: {
          agua: "",
          beneficiarios: "",
        },
        TD: {
          agua: "",
          beneficiarios: "",
        },
        BF: {
          agua: "",
          beneficiarios: "",
        },
        MW: {
          agua: "",
          beneficiarios: "",
        },
        KE: {
          agua: "",
          beneficiarios: "",
        },
        PH: {
          agua: "50 letrinas y mejora del acceso al agua potable",
          beneficiarios: "400 beneficiarios",
        },
        GT: {
          agua: "30 depósitos de agua",
          beneficiarios: "136 beneficiados",
        }
      },
    };
  },
};
</script>
<style>
.vue-world-map #IN,
.vue-world-map #PE,
.vue-world-map #CD,
.vue-world-map #CM,
.vue-world-map #GM,
.vue-world-map #TZ,
.vue-world-map #BJ,
.vue-world-map #MZ .vue-world-map #HT,
.vue-world-map #AO,
.vue-world-map #MZ,
.vue-world-map #HT,
.vue-world-map #MA,
.vue-world-map #TD,
.vue-world-map #BF,
.vue-world-map #MW,
.vue-world-map #KE,
.vue-world-map #PH,
.vue-world-map #GT {
  fill: #b91e2b !important;
}

.vue-world-map .land {
  fill: #b91e2b57;
  stroke: white;
  stroke-width: 0.1px;
}

.vue-map-legend {
  background: #0090be !important;
  width: max-content !important;
  max-width: 400px;
}

.vue-map-legend * {
  color: white;
}

.vue-map-legend-header .title-map {
  font-size: 20px;
  font-weight: bold;
  text-align: left;
}

.vue-map-legend-header .water {
  text-align: left;
  font-size: 16px;
  padding-left: 30px;
  min-height: 25px;
  background-image: url("/static/img/icon-agua.svg");
  background-repeat: no-repeat;
  background-size: 23px;
  background-position: left top;
  margin: 5px 0;
}

.vue-map-legend-header .person {
  text-align: left;
  font-size: 16px;
  padding-left: 30px;
  min-height: 25px;
  background-image: url("/static/img/icon-person.svg");
  background-repeat: no-repeat;
  background-size: 25px;
  background-position: left top;
  margin: 5px 0;
}

.container-map {
  width: 100%;
  /* overflow: hidden; */
}
</style>



// WEBPACK FOOTER //
// src/components/parts/map-agua.vue